/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property } from '@cds/core/internal';
import { getPointer } from './utils/pointer.utils.js';
import styles from './pointer.element.scss';
/**
 * ```typescript
 * import '@cds/core/internal-components/popup/register.js';
 * ```
 *
 * ```html
 * <cds-internal-pointer></cds-internal-pointer>
 * ```
 *
 * @beta
 * @element cds-internal-pointer
 * @slot - Content slot to override the default pointer SVG
 * @cssprop --pointer-fill
 * @cssprop --pointer-outline
 * @cssprop --transform
 *
 */
export class CdsInternalPointer extends LitElement {
    constructor() {
        super(...arguments);
        this.axisAlign = 'start';
    }
    get pointerTemplate() {
        return getPointer(this.type);
    }
    render() {
        // this prevents an impossible state where you have a custom SVG inside of a typed pointer
        return this.type ? getPointer(this.type) : html `<slot></slot>`;
    }
    connectedCallback() {
        super.connectedCallback();
        this.ariaHidden = 'true';
    }
    static get styles() {
        return [styles];
    }
}
__decorate([
    property({ type: String })
], CdsInternalPointer.prototype, "axisAlign", void 0);
__decorate([
    property({ type: String })
], CdsInternalPointer.prototype, "type", void 0);
